import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    const id = window.location.hash.slice(1)
    if (!id) return

    requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'instant' })
    })
  }
}
